import { useQuery } from '@tanstack/react-query';
import type { Periode } from '@vip/shared';
import { api } from '../../lib/apiClient';

export interface Vergelijking {
  nu: number;
  vorige: number;
}

export interface Reeks {
  id: string;
  label: string;
}

export interface Deelonderwerp {
  id: string;
  label: string;
  aantal: number;
  /** In hoeveel verschillende gesprekken dit voorkwam. Zie het gelijknamige
   *  veld in `shared/src/domain/overzicht.ts`: breedte wordt op gesprekken
   *  gemeten en niet op personen, want de transcriptie kent geen sprekers. */
  gesprekken: number;
}

export interface TopOnderwerp extends Deelonderwerp {
  deelonderwerpen: Deelonderwerp[];
}

export interface Verschuiving {
  id: string;
  label: string;
  nu: number;
  vorige: number;
  /** `nu - vorige`. Negatief betekent afgenomen. */
  verschil: number;
  nieuw: boolean;
  weg: boolean;
}

export interface OverzichtData {
  periode: Periode;
  vorige: { periode: string; label: string };
  beschikbaar: { maanden: string[]; jaren: string[] };
  kpi: {
    gesprekken: Vergelijking;
    buddies: Vergelijking & { totaal: number };
    hulpvragen: Vergelijking;
    nieuweOnderwerpen: Vergelijking;
  };
  /** Per tijdvak, niet opgeteld. Zelfde reeksen als `ontwikkeling`. */
  verdeling: {
    reeksen: Reeks[];
    punten: Array<Record<string, string | number>>;
  };
  ontwikkeling: {
    reeksen: Reeks[];
    punten: Array<Record<string, string | number>>;
  };
  verschuivingen: Verschuiving[];
  topOnderwerpen: TopOnderwerp[];
}

/** `periode` is "2026-08" of "2026"; leeg laat de server het jaar kiezen. */
export function useOverzicht(periode?: string) {
  return useQuery({
    queryKey: ['overzicht', periode ?? null],
    queryFn: () => api.get<OverzichtData>(`/dashboard${periode ? `?periode=${periode}` : ''}`),
  });
}
